<template lang="pug">
  .component-backoffice-driver-list.row.column
    DriverListForm(@setSearch="setSearch")
    base-list(:component="component", :dataLoader="dataLoader", :search="search")
      header-columns(slot="before", :columns="headers")
</template>

<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'

  import InputForm from "../../components/structure/ui/filters/InputForm";
  import BaseList from "./BaseList";
  import HeaderColumns from "../../components/structure/ui/HeaderColumns";
  import DriverListForm from '../../components/structure/ui/filters/DriverListForm'

  export default {
    name: "DriverList",
    components: {
      DriverListForm,
      HeaderColumns,
      BaseList,
      InputForm,
    },
    data: function () {
      return {
        component: require('src/components/backoffice/Driver.vue'),
        headers: ['', 'Driver ID', 'Name', 'Client', 'City', 'Registered', 'Phone & Mail', ''],
        search: {}
      }
    },
    methods: {
      setSearch(search) {
        this.search = search
      },
      dataLoader(callback, page, resultsPerPage, search) {
        // We have the input-form compiled?
        if (search && search.query) {

          KeplerBackofficeSdk.drivers.list(page, resultsPerPage, search).search((items) => {
            callback(items)
          })

        } else {
          KeplerBackofficeSdk.drivers.list(page, resultsPerPage, search).all((data) => {
            callback(data)
          })
        }
      },
    }
  }
</script>

<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// DriverList.vue?3bd798d6